<template>
    <base-modal size="xl" hide-header hide-footer @close="">
        <div class="col-12" @click.stop="">
            <div
                class="trip-results"
                style="height: 65vh !important;"
            >
                <map-container
                    ref="mapContainer"
                    :menu-items="menuItems"
                    :find-user="false"
                    @onMapClicked="mapClicked"
                    @onDrag="onDrag"
                    @onDragEnd="onDragEnd"
                    @onMapChanged="mapChanged"
                />
                <div v-if="summaryItem" class="map-trip-details-info-container px-2 pb-1" style="float: left">
                    <div class="row px-1">
                        <div class="col-10 upper-text nopads px-2 pt-2">
                            {{ summaryItem.contract }}
                        </div>
                        <div class="col-2 text-end pt-1" @click.stop="infoCollapsed = !infoCollapsed">
                            <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header upper-text nopads" :class="{ rotated:infoCollapsed }"/>
                        </div>
                    </div>
                    <div class="col-12 summary-text py-0" style="font-size: .8em;">
                        {{ (summaryItem.date.replace('T00:00:00', '')) }}
                    </div>

                    <!-- Collapsable content -->
                    <div class="routa-collapse" :class="{ collapsed: infoCollapsed }">
                        <div class="col-12 summary-text">
                            {{ summaryItem.order ? getOrderAndExecutorStr(summaryItem.order) : '-' }}
                        </div>
                        <div class="col-12 summary-text">
                            {{ summaryItem.vehicle }},
                            {{ summaryItem.driver }}
                        </div>
                        <hr class="orange-divider"/>
                        <div class="col-12 summary-text">
                            {{ $t('trip_list.duration') + ' (H:mm): ' +  getWorkTime(this.sumDuration) }}
                        </div>
                        <div class="col-12 summary-text">
                            {{ $t('trip_list.trip_length') +  ': ' + sumLength.toFixed(1) }}
                        </div>
                        <div class="col-12 summary-text">
                            {{ $t('daily_summary.road_distance') + ': ' + sumRoadCoverage.toFixed(1) }}
                        </div>
                        <div class="col-12 summary-text">
                            <b>{{ $t('daily_summary.total_weight') + ': ' + totalWeight.toFixed(1) + ' ' + 't' }}</b>
                            <b style="color: #fa7676" v-if="tripWeightConflict"> ({{ tripWeight.toFixed(2) + ' ' + 't' }})</b>
                        </div>
                    </div>
                </div>
                <div class="map-controls mt-1">
                    <div class="map-controls__list col-12 col-lg-4 nopads">
                        <measure-distance-map
                            v-if="measureDistanceEnabled"
                            ref="measureDistances"
                            :map="map"
                            :measure-distance-results="measureDistances"
                            :measure-distance-target-item="measureDistanceTargetItem"
                            :measure-distance-target-item-callback="measureDistanceTargetItemCallback"
                            :draggable="true"
                            @onRemoveMeasureDistances="removeMeasureDistances"
                        />
                        <measure-road-map
                            v-if="measureRoadEnabled"
                            ref="measureRoad"
                            :map="map"
                            :hide-make-new-observation-button="true"
                            :draggable="true"
                            @close="measureRoadEnabled = false"
                            @confirmSelection="createLineObservation"
                        />
                    </div>
                </div>
                <trip-map
                    v-if="map"
                    ref="tripMap"
                    :trip-results="trips"
                    :trip-item="mapItem"
                    :map="map"
                    :show-trip-info="false"
                    :area-group="areaGroup"
                    @setCurrentPoint="setCurrentPoint"
                    @carPositionSimulating="setCarPositionSimulating"
                />
                <trip-map
                    v-if="map"
                    ref="tripAllTripsMap"
                    :trip-results="previousOrderTrips"
                    :map="map"
                    :show-trip-info="false"
                    :focus="false"
                    :line-opacity="0.5"
                    :line-width="2"
                    :trace-type="OTHER"
                    static-line-color="#000000"
                />
            </div>
            <div class="map-trip-details-table pl-1 pt-1 pr-1">

                <vue3-datatable
                    v-if="tableItems.length > 0"
                    ref="resultTable"
                    :rows="tableItems"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="10em"
                    :sortable="true"
                    skin="bh-table-compact"
                    :row-class="getRowClass"
                    cell-class="routa-table-cell"
                    @row-click="showTripOnMap"
                >
                    <template #tripnote="row">
                        <span  v-for="tripNote in row.value.tripnotes" v-bind:key="tripNote.id">
                            <span class="tooltip-title">{{ toLocalTime(tripNote.start_time) }}-{{ toLocalTime(tripNote.end_time) }}</span>
                            {{ tripNote.note }}
                        </span>
                    </template>
                </vue3-datatable>
            </div>
            <div class="row nopads">
                <div class="col-md-6 nopads">
                    <div v-if="mapItem" class="d-flex justify-content-start">
                        <button
                            class="btn btn-primary form-button"
                            style="min-width: 7em"
                            :disabled="allTrips === true"
                            @click="showAllTrips"
                        >
                            {{ $t('common.show_all') }}
                        </button>
                        <button
                            class="btn btn-success form-button"
                            style="min-width: 7em"
                            :disabled="mapItem == null || this.withGeom === false"
                            @click="simulateTrip"
                        >
                            {{ $t('trip.simulate_trip') }}
                        </button>
                    </div>
                </div>
                <div class="col-md-6 d-flex justify-content-end align-items-center">
                    <div v-if="orderGeometry && orderGeometry.length > 0" class="form-check form-switch me-3">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="showOrderGeometry"
                            @change="toggleOrderGeometry"
                            id="showOrderGeometrySwitch"
                        >
                        <label class="form-check-label" for="showOrderGeometrySwitch">
                            {{ $t('orders.show_geometry') }}
                        </label>
                    </div>
                    <div  v-if="allowPreviousTripsFetching" class="form-check form-switch me-3">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="showOrderAllTrips"
                            :disabled="loading > 0"
                            id="showOrderAllTripsCheckbox"
                        >
                        <label class="form-check-label" for="showOrderAllTripsCheckbox">
                            {{ $t('trip.show_all_order_previous_trips') }}
                        </label>
                    </div>
                    <button class="btn btn-secondary form-button" @click.stop="close">
                        {{ $t('common.close') }}
                    </button>
                </div>
            </div>
        </div>

        <base-modal
            v-if="roadCoverageModal"
            hide-footer
            hide-header-close
            size="sm"
            :title="$t('daily_summary.road_coverage_calculation')">
            <div class="col-12">
                <font-awesome-icon icon="exclamation-triangle" class="hint-text" style="margin-right: 1em; margin-top: .2em"/>
                <span class="hint-text">{{ $t('daily_summary.road_coverage_disclaimer')}}</span>
            </div>
            <div class="col-12 pt-2">
                <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="roadCoverage"
                    id="roadCoverageCheckbox"
                >
                <label class="form-check-label ms-2" for="roadCoverageCheckbox">
                    {{ $t('daily_summary.road_coverage') }}
                </label>
            </div>
            <div class="button-container">
                <button
                    class="btn btn-primary form-button"
                    @click.stop="fetchTrips">
                    <span class="map-button-text">{{ $t('common.continue') }}</span>
                </button>
            </div>
        </base-modal>

        <google-street-view-link
            v-if="streetViewDialogCoordinates"
            ref="streetView"
            :latLon="streetViewDialogCoordinates"
            :hide-text="true"
            @dialog-closed="streetViewDialogCoordinates = null"
        />

        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </base-modal>
</template>

<script>
import {orderMixin} from "@/components/mixins/OrderMixin";
import MapContainer from "../map/MapContainer";
import TripMap from '../trip/TripMap'
import {restApi} from "../mixins/RestApiMixin";
import {timeUtils} from '../mixins/TimeUtils'
import MeasureDistanceMap from "../map/MeasureDistanceMap";
import MeasureRoadMap from "../map/MeasureRoadMap";
import {measureDistanceMixin} from "../mixins/MeasureDistanceMixin";
import {vehicleHelper} from "../mixins/VehicleMixin";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";
import Vue3Datatable from '@bhplugin/vue3-datatable'
import GoogleStreetViewLink from "@/components/utils/GoogleStreetViewLink";
import {mapHelper} from "../mixins/MapMixin.js";


export default {
    name: "ContractTripDetails",
    components: {
        GoogleStreetViewLink,
        BaseModal, MapContainer, TripMap, MeasureDistanceMap, MeasureRoadMap, Vue3Datatable},
    mixins: [orderMixin, restApi, timeUtils, measureDistanceMixin, vehicleHelper, mapHelper],
    props: {
        summaryItem: {
            type: Object,
            default: null
        },
        orderItem: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            sumDuration: 0,
            sumRoadCoverage: 0,
            roadCoverage: false,
            streetViewDialogCoordinates: null,
            sumLength: 0,
            totalWeight: 0,
            currentPoint: 0,
            currentTime: null,
            currentSpeed: 0,
            isCarSimulating: false,
            vehicle: null,
            map: null,
            order: null,
            withGeom: false,
            tableItems: [],
            previousOrderTrips: [],
            trips: [],
            loading: 0,
            mapItem: null,
            selectMode: 'single',
            areaGroup: null,
            allTrips: true,
            infoCollapsed: true,
            measureRoadEnabled: false,
            showOrderAllTrips: false,
            roadCoverageModal: false,
            measureDistances: [],
            measureDistanceEnabled: false,
            measureDistanceTargetItem: null,
            orderGeometry: null,
            showOrderGeometry: true,
            allowPreviousTripsFetching: false,
            fields: [
                {
                    field: "start_time",
                    title: this.$t('trip_list.start_time'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "end_time",
                    title: this.$t('trip_list.end_time'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "mode",
                    title: this.$t('trip_list.mode'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "duration",
                    title: this.$t('trip_list.duration') + ' (min)',
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "trip_length",
                    title: this.$t('trip_list.trip_length'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "road_coverage",
                    title: this.$t('daily_summary.road_distance'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "delivery",
                    title: this.$t('contract_reports.unload_records.delivery_id'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: "tripnote",
                    title: this.$t('daily_summary.trip_notes'),
                    sort: false,
                    headerClass: 'routa-table-header'
                }
            ]
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.map = this.$refs.mapContainer.getMap()
            if (this.map && this.summaryItem.unhandled_coverage_areas) {
                this.map.addGeoJsonObjects(this.summaryItem.unhandled_coverage_areas, false, '#9e0c0c', false, 0.5)
            }
        })
        this.roadCoverageModal = true
        this.fetchAreaGroup()
        this.fetchOrderGeometry()
        this.totalWeight = this.summaryItem && this.summaryItem.delivery_tons
        this.allowPreviousTripsFetching = this.orderItem && this.orderItem.pricing_model && parseInt(this.orderItem.pricing_model.unit1) === 4 &&
            parseInt(this.orderItem.pricing_model.unit2) === 108
    },
    computed: {
        menuItems() {
            return [
                {
                    text: "Google Street View",
                    onClick: this.showStreetView
                },
                !this.measureDistanceEnabled ? {
                    text: this.$t('map.measure_distance'),
                    onClick: this.initMeasureDistance
                } : {
                    text: this.$t('map.remove_measurements'),
                    onClick: this.removeMeasureDistances
                },
                !this.measureRoadEnabled ? {
                    text: this.$t('map.measure_road'),
                    onClick: this.initMeasureRoad
                } : {
                    text: this.$t('map.remove_measurements'),
                    onClick: this.removeMeasureRoads
                }
            ]
        },
        tripWeightConflict() {
            if (this.trips.length < 1) {
                return false
            }
            return this.tripWeight.toFixed(2) !== this.totalWeight.toFixed(2)
        },
        tripWeight() {
            return this.trips.reduce((sum, item) => {
                return sum + (typeof item.delivery_amount === 'number' && item.delivery_unit === 't' ? item.delivery_amount : 0);
            }, 0);
        }
    },
    watch: {
        orderItem() {
            this.allowPreviousTripsFetching = this.orderItem && this.orderItem.pricing_model && parseInt(this.orderItem.pricing_model.unit1) === 4 &&
                parseInt(this.orderItem.pricing_model.unit2) === 108
        },
        showOrderAllTrips() {
            this.allOrderTripsChanged()
        }
    },
    methods: {
        getRowClass(row) {
            return this.mapItem && row.id === this.mapItem.id ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.trips.length) {
                this.selectedRowId = this.trips[index].id
            }
        },

        sumTrips: function () {
            if (this.trips.length > 0) {
                this.trips.forEach(function (trip) {
                    this.sumRoadCoverage += trip.road_coverage ? trip.road_coverage / 1000 : 0
                    this.sumLength += trip.length
                    let duration = this.getDurationInMinutes(trip.start_time, trip.end_time)
                    this.sumDuration += duration
                }, this)
            }
        },
        onDrag: function (data) {
            if (this.measureDistanceEnabled) {
                this.updateMeasureDistance(data)
            }
        },

        onDragEnd: function (data) {
            if (this.measureDistanceEnabled) {
                this.$refs.measureDistances.updatePoint(data)
            }
            if (this.measureRoadEnabled) {
                this.$refs.measureRoad.addMeasurePoint(data)
            }
        },

        mapClicked: function (coord) {
            if (this.measureDistanceEnabled) {
                this.$refs.measureDistances.addPoint(coord)
            }

            if (this.measureRoadEnabled) {
                this.$refs.measureRoad.addMeasurePoint(coord)
            }
        },
        fetchAreaGroup: function() {
            if (this.summaryItem.area_id) {
                this.areaGroup = null
                this.loading++
                this.restFetch(this.areaGroupUrl + '/id/' + this.summaryItem.area_id, this.handleAreaGroupResponse)
            }
        },
        handleAreaGroupResponse: function (response) {
            this.loading--
            if (response) {
                this.areaGroup = response.data
            }
        },

        initTableItems: function () {
            this.tableItems = []
            const temp = []
            if (this.trips.length > 0) {
                this.trips.forEach(function (item) {
                    temp.push({
                        start_time: this.toLocalTime(item.start_time),
                        end_time: this.toLocalTime(item.end_time),
                        duration: this.getDurationInMinutes(item.start_time, item.end_time),
                        mode:  this.getTripModeString(item.mode),
                        trip_length: item.length.toFixed(2),
                        road_coverage: item.road_coverage ? (item.road_coverage/1000).toFixed(2) : '-',
                        id: item.id,
                        delivery: item.delivery_amount ? item.delivery_amount + ' ' + item.delivery_unit : '-',
                        tripnotes: item.tripnotes
                    })
                }, this)
                this.$nextTick(() => {
                    this.tableItems = temp
                })
            }
        },
        close: function () {
            this.$refs.tripMap.resetMap()
            this.$emit('close')
        },
        simulateTrip: function () {
            this.$refs.tripMap.showMovingCar()
        },
        setCurrentPoint: function (currentPoint) {
            this.currentPoint = currentPoint
            // Check if mapItem and relevant arrays are available
            if (this.mapItem && this.mapItem.timestamps && this.mapItem.timestamps.length > 0 && this.mapItem.geometry && this.mapItem.geometry.length > 0) {
                // Get current timestamp and geometry
                let currentTime = this.mapItem.timestamps[this.currentPoint];
                this.currentTime = currentTime.substring(11, 16)
                let currentGeometry = this.mapItem.geometry[this.currentPoint];

                // Check if there are consecutive points available
                if (this.currentPoint < this.mapItem.timestamps.length - 1) {
                    // Get next timestamp and geometry
                    let nextTime = this.mapItem.timestamps[this.currentPoint + 1];
                    let nextGeometry = this.mapItem.geometry[this.currentPoint + 1];

                    // Calculate speed between current and next points
                    let speed = this.calculateSpeed(
                        currentGeometry.x, currentGeometry.y,
                        nextGeometry.x, nextGeometry.y,
                        currentTime, nextTime
                    );
                    if(speed !== Infinity) {
                        this.currentSpeed = speed.toFixed(2)
                    }
                }
            }
        },
        setCarPositionSimulating(isCarPositionSimulating) {
            this.isCarSimulating = isCarPositionSimulating
        },
        fetchTrips: function () {
            this.roadCoverageModal = false
            let params = {}
            this.trips = []
            this.tableItems = []
            if(this.summaryItem) {
                params.user = this.summaryItem.driver_id
                params.vehicle = this.summaryItem.vehicle_id
                params.order = this.summaryItem.order ? this.summaryItem.order.id : undefined
                params.customer = this.summaryItem.customer_id
                params.contractor = this.summaryItem.contractor_id
                params.contract = this.summaryItem.contract_id
                params.area_group = this.summaryItem.area_id && this.summaryItem.report_tracking_mode === 1 ? this.summaryItem.area_id : undefined // Use area only if tracking is limited inside area(s)
                params.with_geom = 1
                params.road_coverage = this.roadCoverage ? 1 : 0,
                params.trip_notes = 1
                params.from = new Date(this.summaryItem.date).toISOString()
                params.to = new Date(this.summaryItem.date.replace('00:00:00', '23:59:59')).toISOString()
                params.timestamps = 1
                params.speed = 1
                if (!this.summaryItem.order) {
                    params.empty_order = true
                }
                this.loading++
                this.restFetchParams(this.tripUrl, params, this.handleResponseTrips, this.handleError)
            }
        },
        handleResponseTrips: function (response) {
            this.loading--
            this.trips = response.data
            this.initTableItems()
            this.sumTrips()
        },
        fetchAllTrips() {
            let params = {}
            if(this.summaryItem && this.summaryItem.order.id) {
                this.previousOrderTrips = []
                params.order = this.summaryItem.order.id
                params.with_geom = 1
                params.from = new Date(this.orderItem.create_time).toISOString()
                params.to = new Date(this.summaryItem.date).toISOString()
                params.contract = this.summaryItem.contract_id
                this.loading++
                this.restFetchParams(this.tripUrl, params, this.handleResponseAllTrips, this.handleError)
            }
        },

        handleResponseAllTrips: function (response) {
            this.loading--
            this.previousOrderTrips = response.data
            if(this.previousOrderTrips.length > 0) {
                this.showOrderAllTrips = true
                this.previousOrderTrips.forEach(trip => {
                    trip.mode = 1
                })
            } else {
                this.showAlert(this.$t('trip_list.err_no_previous_trips'))
            }
        },

        handleError: function () {
            this.loading--
            this.showAlert(this.$t('trip_list.err_general'))
        },
        showTripOnMap: function (item) {
            if (!item) {
                this.mapItem = null;
                this.$refs.tripMap.resetMap()
                this.showAllTrips()
            } else if (!this.mapItem || this.mapItem.id != item.id) {
                this.allTrips = false
                this.mapItem = null
                if (this.$refs.tripMap) {
                    this.$refs.tripMap.resetMap()
                }
                let trip = this.trips.find(trip => trip.id === item.id)
                if (trip.geometry.length > 1) {
                    this.withGeom = true
                    this.mapItem = trip
                } else {
                    this.withGeom = false
                }
            }
        },

        showAllTrips: function () {
            this.loading++
            this.mapItem = null
            this.allTrips = true
            this.loading--
        },

        mapChanged(map) {
            this.map = map
            this.refreshMapGeometries()
        },

        allOrderTripsChanged() {
            if(this.showOrderAllTrips && this.previousOrderTrips.length === 0) {
                this.fetchAllTrips()
            } else if(this.showOrderAllTrips) {
                this.$refs.tripAllTripsMap.initView()
            } else {
                this.$refs.tripAllTripsMap.hideTrips()
            }
        },

        fetchOrderGeometry: function () {
            if (this.summaryItem.order && this.summaryItem.order.id) {
                this.loading++
                this.restFetch(this.orderUrl+'/'+this.summaryItem.order.id+'/geometry',this.handleOrderGeometry)
            }
        },

        handleOrderGeometry: function (response) {
            this.loading--
            if (response && response.data) {
                this.orderGeometry = response.data.length > 0 ? response.data : null
                if (this.orderGeometry && this.orderGeometry.length > 0) {
                    this.addGeoJsonMapObjects()
                }
            }
        },

        addGeoJsonMapObjects() {
            if (this.showOrderGeometry && this.orderGeometry) {
                this.orderGeometry.forEach((item) => {
                    if(item.visibility) {
                        this.map.addGeoJsonObjects(JSON.stringify(item.geometry), false, item.color, item.add_polyline_ends,
                            item.transparency ? item.transparency : 1, item.line_width ? item.line_width : 3)
                    }
                })
            }
        },

        toggleOrderGeometry() {
            if (this.showOrderGeometry) {
                this.addGeoJsonMapObjects()
            } else {
                this.$refs.mapContainer.hideImportedObjects()
            }
        },

        refreshMapGeometries() {
            this.$refs.mapContainer.hideImportedObjects()
            if (this.summaryItem.unhandled_coverage_areas) {
                this.map.addGeoJsonObjects(this.summaryItem.unhandled_coverage_areas, false, '#9e0c0c', false, 0.5)
            }
            this.addGeoJsonMapObjects()
        },

        showStreetView(coord) {
            if (coord) {
                this.streetViewDialogCoordinates = {lat: coord.lat, lon: coord.lng}
                this.$nextTick(() => this.$refs.streetView.showPrompt())
            }
        },

    }
}
</script>
<style scoped>

.map-trip-details-table {
    white-space: nowrap;
    background: rgba(255, 255, 255, 0.7);
    overflow: hidden;
    max-height: 10em;
}

.map-trip-details-info-container {
    background-color: rgba(43, 43, 43, 0.8);
    border: 1px solid #404041;
    min-width: 20em;
    z-index: 2;
    margin: .5em;
    position: relative;
    width: fit-content;
    border-radius: .5em;
}

.summary-text {
    color: #FFFFFF;
    text-shadow: 1px 1px #000000;
    font-size: .9em;
}

.upper-text {
    text-transform: uppercase;
    color: #BEFF41;
}

.orange-divider {
    border-color: #90b677;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: .1em;
    margin-right: .1em;
}
.tooltip-title {
    display: block;
    color: black;
    font-weight: 800;
    font-size: 0.9em;
    text-transform: uppercase;
    line-height: 1.6;
    margin-top: .5em;
}

</style>
